<template>
    <!--用户注册-->
    <div class="register">
        <div class="header">
            <img src="../../imgs/ico10.png" alt="">Reset Password
        </div>
        <ul class="reg-box">
            <li class="errmsg">
                {{msg}}
            </li>
            <li>
                <label>
                    <span>E-mail</span>
                    <input type="text" v-model="userData.email" placeholder="E-mail">
                </label>
            </li>
            <li>
                <label>
                    <span>Code</span>
                    <input type="text" v-model="userData.code" placeholder="Code" style="width:450px">
                    <button @click="getCode" style="width:160px;background-color:#AE0D73;color:#FFF;border:0;height:40px;margin-left:50px;cursor:pointer">Get code</button>
                </label>
            </li>
            <li>
                <label>
                    <span>Password</span>
                    <input type="password" v-model="userData.pwd" placeholder="Password">
                </label>
            </li>
            <li>
                <label>
                    <span>Confirm Password</span>
                    <input type="password" v-model="userData.cpwd" placeholder="Confirm Password">
                </label>
            </li>
        </ul>
        <div class="reg-btn-box">
            <button @click="doReg">Reset</button>
        </div>
    </div>
</template>
<script>
/*
   * /api/register/add
   * firstpy   lastpy   email  pwd language
   language en
   * */
import md5 from 'md5';
export default {
    data() {
            return {
                showErrorMsg: false,
                showMsg: false,
                msg: '',
                userData: {
                    email: '',
                    code: '',
                    pwd: '',
                    cpwd: '',
                    language: 'en'
                }
            }
        },
        props: {},
        methods: {
            //去往注册页面
            getCode() {
                if (this.userData.email.trim().length === 0) {
                    this.msg = 'Please input your email';
                    this.showMsg = true;
                    return;
                }
                axios.post('/medapp/api/register/identify', {
                    email: this.userData.email,
                    type: "FIND",
                    language:"en",
                }).then((result) => {
                    if(result.data.code=="0"){
                      this.$Message.success('Verification code sent', 3);
                      console.log(result.data.identify);
                    }else if(result.data.code=="1002"){
                      this.$Message.warning('Your email is not registered', 3);
                      console.log(result.data.code);
                    }
                    
                });
            },
            doReg() {
                let userData = this.userData;
                if (this.userData.email.trim().length === 0) {
                    this.msg = 'Please input your email';
                    this.showMsg = true;
                    return;
                } else if (this.userData.code.trim().length === 0) {
                    this.msg = 'Please input identify code';
                    this.showMsg = true;
                    return;
                } else if (this.userData.pwd.trim().length === 0) {
                    this.msg = 'Please input your password';
                    this.showMsg = true;
                    return;
                } else if (this.userData.cpwd.trim().length === 0) {
                    this.msg = 'Please input your confirm password';
                    this.showMsg = true;
                    return;
                } else if (this.userData.cpwd != this.userData.pwd) {
                    this.msg = 'Your password and confirm password must be the same';
                    this.showMsg = true;
                    return;
                }else {
                    this.showMsg = false;
                }
                axios.post('/medapp/api/register/changepwd', {
                        email: userData.email,
                        pwd: md5(userData.pwd),
                        identify: userData.code,
                    })
                    .then((result) => {
                        console.log(result.data);
                        let data = result.data;
                        //            用户修改密码成功
                        if (data.code === '0') {
                            this.$Message.success('Password modification success', 3);
                            this.$router.push('/home_en/2006/detail/login');
                        } else if(data.code === '1007'){
                            this.msg = 'Your email is not registered ';
                            this.showMsg = true;
                        }else if(data.code === '1003'){
                            this.msg = 'invalid identify';
                            this.showMsg = true;
                        }
                    })
            }
        },
        computed: {},
        mounted() {}
}
</script>
<style scoped>
.login {
    text-align: right;
}

.login p {
    display: inline-block;
    cursor: pointer;
}

.register {
    font-family: "Arial";
}

.reg-box .errmsg {
    color: red;
    font-size: 14px;
    margin-left: 147px;
}

.header {
    height: 89px;
    background-color: #F4F4F7;
    color: #4C4E82;
    font-size: 22px;
    line-height: 89px;
}

.header img {
    vertical-align: middle;
    margin-left: 50px;
    margin-right: 21px;
}


/*注册框开始*/

.reg-box {
    width: 905px;
    margin: 48px auto 0;
    font-size: 20px;
}

.reg-box li {
    margin: 20px 0;
}

.reg-box label span {
    display: inline-block;
    width: 200px;
    text-align: right;
    line-height: 40px;
    color: #000;
    margin-right: 20px;
}

.reg-box label input {
    width: 665px;
    height: 40px;
    background-color: #f3f3f6;
    border: 1px solid #141651;
    padding-left: 18px;
    box-sizing: border-box;
    font-size: 20px;
}

.reg-btn-box {
    text-align: center;
    margin-top: 84px;
}

.reg-btn-box button {
    color: #FFFFFF;
    font-size: 22px;
    border: 0;
    background-color: #141651;
    padding: 12px 63px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// resetpass.vue?c9550674